const mediaQuerySettings = {
  mediaTarget: 'all',

  breakPoints: {
    xs: null, // 0   ~ 320 : Phone (Narrow)
    sm: 321,  // 321 ~ 709 : Phone
    md: 710,  // 710 ~     : Desktop
  },

  groups: {
    sp         : {max: 'sm'}, // Phone
    pc         : {min: 'md'}, // Tablet, Desktop
    spLandscape: {max: 'md', orientation: 'landscape'},
  },
};



module.exports = mediaQuerySettings;



// WEBPACK FOOTER //
// ./config/media-query-settings.js